export function getColorScale(colorScale) {
  const scale = (value) => {
    const matchingStep = colorScale.find(c => value < c[0]);

    if (typeof matchingStep === 'undefined') {
      return colorScale[colorScale.length - 1][1];
    }

    return matchingStep[1];
  };

  scale.colors = colorScale.map(c => c[1]);
  scale.values = colorScale.map(c => c[0]);

  return scale;
}